import { writable } from 'svelte/store';

// mapCredits is whether this browser's maps show their credit (spec 009):
// on unless the member turned it off in Settings.
const STORAGE_KEY = 'kehai.mapCredits';

function read(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) !== 'off';
  } catch {
    // Storage can be off in private windows; the credits show.
    return true;
  }
}

export const mapCredits = writable<boolean>(read());

// setMapCredits records the member's choice for this browser.
export function setMapCredits(on: boolean) {
  try {
    if (on) localStorage.removeItem(STORAGE_KEY);
    else localStorage.setItem(STORAGE_KEY, 'off');
  } catch {
    // Not kept past this page when storage is off.
  }
  mapCredits.set(on);
}
